export enum PermissionModules {
    Analytics_Dashboard = "Analytics Dashboard",
    Meeting = "Meeting",
    Statistics = "Statistics",
    Library = "Library",
    Sampling_Manager = "Sampling Manager",
    Recording_Manager = "Recording Manager",
    Alerts = "Alerts",
    Audit_Manager = "Audit Manager",
    User_Manager = "User Manager",
    Role_Manager = "Role Manager",
    Topic_Manager = "Topic Manager",
    Integrations = "Integrations",
    Team_Manager = "Team Manager",
    Call_Type_Manager = "Call Type Manager",
    Call_Tags_Manager = "Call Tags Manager",
    Scheduled_Reports = "Scheduled Reports",
    Billing = "Billing",
    Score_Sense = "Score Sense",
    Reports = "Reports",
    General = "General",
    Coaching = "Coaching",
    QMS = "QMS",
    CI = "Convin Insights",
    Accounts = "Accounts",
    Agent_Assist = "Agent Assist",
    Violation_Manager = "Violation Manager",
    Gpt_Features = "GPT Features",
    AI_Agent = "AI Agent",
    Accuracy_Dashboard = "Accuracy Dashboard",
    Support_Dashboard = "Support Dashboard",
}

export enum PermissionTypes {
    edit = "edit",
    view = "view",
    delete = "delete",
}

/**
 * Meaningful, per-dashboard permission code_names for the customer support
 * dashboards (Repeat Calls, Escalation, Customer Intent, Customer
 * Satisfaction).
 *
 * TODO: the backend currently exposes a single shared "Support Dashboard"
 * permission group (`analytics.manage_support_dashboard`) covering all 4
 * dashboards — every value below resolves to that same code_name today.
 * Replace each with its own dedicated code_name once the backend splits
 * them out (e.g. `analytics.manage_escalation_dashboard`).
 */
export const SupportDashboardPermissionCodeNames = {
    RepeatCalls: "analytics.manage_support_dashboard",
    Escalation: "analytics.manage_support_dashboard",
    CustomerIntent: "analytics.manage_support_dashboard",
    CustomerSatisfaction: "analytics.manage_support_dashboard",
} as const;
